import React from "react";
import Form from "react-bootstrap/Form";
import { Row, Col } from "react-bootstrap";
import Dropdown from "react-bootstrap/Dropdown";
import InputGroup from "react-bootstrap/InputGroup";
import searchIcon from "../../../assets/images/svg/search_lines_icon.svg";
function Actions(props) {
  return (
    <Row>
      <Col xxl="auto" xl="auto" lg="2" md="3" xs="4">
        <InputGroup>
          <Form.Control
            className="normal-input margin-zero"
            type="text"
            placeholder="جستجوی خط"
            onChange={(e) => {
              if (e.target.value.length === 0) {
                props.setData(props.storedData);
              } else {
                let result = props.data.filter((obj) => {
                  let prunedNumber = obj.LineNumber.replace("+98", "0");
                  return prunedNumber.includes(e.target.value);
                });                
                props.setData(result);
              }
            }}
          />
          <InputGroup.Text>
            <img src={searchIcon} alt="search icon" />
          </InputGroup.Text>
        </InputGroup>
      </Col>
      <Col xxl="auto" xl="auto" lg="2" md="3" xs="4">
        <Dropdown>
          <Dropdown.Toggle variant="success">
            {props.dropDownFilter}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {props.dropDownItems.map((d, index) => (
              <Dropdown.Item
                href={void 0}
                key={index}
                onClick={() => {
                  props.setFilter(d);
                  props.setFilterValue(index);
                }}
              >
                {d}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </Col>
    </Row>
  );
}
export default Actions;
